import { render, staticRenderFns } from "./ProductQuestion.vue?vue&type=template&id=2ce25646&scoped=true"
import script from "./ProductQuestion.vue?vue&type=script&lang=js"
export * from "./ProductQuestion.vue?vue&type=script&lang=js"
import style0 from "./ProductQuestion.vue?vue&type=style&index=0&id=2ce25646&prod&scoped=true&lang=css"
import style1 from "./ProductQuestion.vue?vue&type=style&index=1&id=2ce25646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce25646",
  null
  
)

export default component.exports